module.exports = __webpack_public_path__ + "img/cybo_logo_dark_1.14cc8d1c.svg";